import React from 'react';
import { toast } from 'react-toastify';
import './RerunValidationsButton.css';

const RerunValidationsButton = ({ onClick, isRerunningValidations, timerActive }) => {
  const handleClick = () => {
    if (isRerunningValidations || timerActive) {
      toast.warn("Cannot rerun validations while processing or timer is active.", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
    onClick();
  };

  return (
    <button
      className="rerun-validations-button btn-contained"
      onClick={handleClick}
      disabled={isRerunningValidations || timerActive}
    >
      {isRerunningValidations ? (
        <span className="rerun-validations-spinner"></span>
      ) : (
        "Rerun Validations"
      )}
    </button>
  );
};

export default RerunValidationsButton;